/**
 *
 * Any functions that modify the global/document object for fg-file-browser
 *
 *  - document.fbStorage = {}
 *  - document.callFBFunctionByName = function
 *
 */

const GLOBAL_KEY = 'fbStorage';

/**
 *
 * Initialise global with required state
 *
 */
function initFileGlobal() {
    document[GLOBAL_KEY] = {
        initialized: true,
        loadedFiles: {},
        dataPointers: [],
    };
}

/**
 *
 * Reset properties back to initial state
 *
 */
function cleanFileGlobal() {
    document[GLOBAL_KEY].loadedFiles = {};
    document[GLOBAL_KEY].dataPointers = [];
}

/**
 *
 * Store the provided file content to the `fbStorage` global
 *
 * @param {string} fileName
 * @param {ArrayBuffer} fileContent
 * @example
 *
 *
 *     storeLoadedFileGlobal('hello.txt', myFile)
 *
 *     document.fbStorage.loadedFiles // would have // { 'hello.txt': myFile }
 *
 */
function storeLoadedFileGlobal(fileName, fileContent) {
    document[GLOBAL_KEY]['loadedFiles'][fileName] = {
        info: fileContent,
    };
}

/**
 *
 * Set up the global callFBFunctionByName function
 *
 * @param {function} callFBFunctionByName
 *
 */
function setGlobalFunction(callFBFunctionByName) {
    document['callFBFunctionByName'] = callFBFunctionByName;
}

export {
    initFileGlobal,
    cleanFileGlobal,
    storeLoadedFileGlobal,
    setGlobalFunction,
};
